import type { Segment } from "@/lib/api";

const labels: Record<Segment, string> = {
  lost: "Lost",
  declining: "Declining",
  stable: "Stable",
  growing: "Growing",
  new: "New",
};

const classes: Record<Segment, string> = {
  lost: "bg-ink-100 text-ink-700",
  declining: "bg-red-50 text-danger",
  stable: "bg-ink-100 text-ink-600",
  growing: "bg-emerald-50 text-success",
  new: "bg-indigo-50 text-accent-600",
};

export default function SegmentBadge({ segment }: { segment: Segment }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${classes[segment]}`}>
      {labels[segment]}
    </span>
  );
}
